import React, { Component } from 'react';
import _ from 'lodash';

import { Grid, Paper, Typography } from '@material-ui/core';

import { WithStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

import { MyPATLink } from '../../../common';

import ContentData from '../../types/ContentData';

const styles = (theme: Theme) => createStyles({
    paperOverview: {
        padding: theme.spacing.unit * 2
    },
    keyValueContainer: {
        '& *': {
            display: 'inline',
            marginRight: '4px',
        },
        marginTop: theme.spacing.unit * 2,
    },
    overviewMeta: {
        opacity: 0.6
    },
    metaInfoBox: {
        padding: theme.spacing.unit,
        marginTop: theme.spacing.unit,
        border: `1px solid ${theme.palette.background.default}`,
        borderRadius: '2px'
    },
    metaInfoBoxTable: {
        border: 0
    },
    titleDesc: {
        marginTop: theme.spacing.unit * 2,
        '& p > img, img': {
			maxWidth: '100%'
		}
    }
});



//@ts-ignore
interface FormulaPreviewProps extends WithStyles<typeof styles> {
    classes: any,
    content: ContentData
}

interface FormulaPreviewStates {
}

class FormulaPreview extends Component<FormulaPreviewProps, FormulaPreviewStates>{
    constructor(props: FormulaPreviewProps) {
        super(props);
    }

    render() {
        const { classes, content } = this.props;

        return (
            <Grid container spacing={16} direction="column">
                <Grid item>
                    <Paper className={classes.paperOverview}>
                        <div className={classes.titleDesc}>
                            <Typography variant="body2" color="primary">Title: </Typography>
                            <Typography variant="body1">
                                <span dangerouslySetInnerHTML={{ __html: _.get(content, "content.content[0].title", "-") }}></span>
                            </Typography>
                        </div>
                        <div className={classes.titleDesc}>
                            <Typography variant="body2" color="primary">Formulas: </Typography>
                            <Typography variant="body1">
                                <span dangerouslySetInnerHTML={{ __html: _.get(content, "content.content[0].content", "-") }}></span>
                            </Typography>
                        </div>
                        <div className={classes.titleDesc}>
                            <Typography variant="body2" color="primary">Derivations: </Typography>
                            <Typography variant="body1">
                                <span dangerouslySetInnerHTML={{ __html: _.get(content, "content.content[0].derivation", "-") }}></span>
                            </Typography>
                        </div>


                        <div className={classes.titleDesc}>
                            <Typography variant="body2" color="primary">Tags</Typography>
                            <Typography variant="body1">
                                {
                                    _.map(_.get(content, 'content.tags', []), (t, i: number) => (
                                        <span key={i}>{_.get(t, 'relation.name', '-')}:{_.isArray(_.get(t, 'values', '-')) ? _.get(t, 'values', '-').join(", ") : _.get(t, 'values', '-')} &nbsp;&nbsp;|&nbsp;&nbsp; </span>
                                    ))
                                }
                            </Typography>
                        </div>
                    </Paper>
                </Grid>
            </Grid>
        )
    }
}


// @ts-ignore
export default withStyles(styles)(FormulaPreview);